import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { useGlobalModals } from "@/app/providers/modal-provider"

/**
 * Generic single-message popup, replacing the legacy's
 * `ScriptManager.RegisterClientScriptBlock` / `ShowMsgPopup` alert pattern
 * used for validation errors and API-failure messages (migration plan §5).
 */
export function AlertModal() {
  const { alert, closeAlert } = useGlobalModals()

  return (
    <Dialog open={alert.open} onOpenChange={(open) => !open && closeAlert()}>
      <DialogContent aria-labelledby="alert-modal-title">
        <DialogHeader>
          <DialogTitle id="alert-modal-title">{alert.title}</DialogTitle>
          <DialogDescription>{alert.description}</DialogDescription>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  )
}
